// Module
var code = `<ul class="error-fields" ng-if="errorFieldsController.fields.length > 0"> <li ng-repeat="field in errorFieldsController.fields"> {{ field.message | translate : ('Error.' + field.code) | translate : field.arguments }} </li> </ul> `;
// Exports
module.exports = code;